import { i18n } from '@lingui/core';

export interface ApprovalPresetGroupsPageParams extends Record<string, string | undefined> {
  projectId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/approval-preset-groups`;
export const TITLE = i18n._('Approval Preset Groups');
